import React from 'react';



export default function NonCustomersDetailEd() {

  return (
    <>
        <h1>THE THREE TIERS OF NONCUSTOMERS</h1>
        <p>The Three Tiers of Noncustomers is a tool that helps visualize the total demand potential of your industry.</p>
        <img src={`${process.env.PUBLIC_URL}/images/3. nonconsum-eng.jpg`} style={{width: 600}}/>
        <p>
          First Tier: «Soon-to-be» noncustomers are those who currently on the edge of your industry, minimally using your offering. When they find a better alternative, they will exchange your service or product for it.
        </p>

        <p>
          Second Tier: «Refusing» noncustomers are those who considered your offer as a possible option for resolving their needs, but then choose against it.
        </p>

        <p>
          Third Tier: «Unexplored» noncustomers are the furthest away from an industry’s existing customers. They never have been considered as potential or target customers by any of the industry’s players, because their needs and the business opportunities associated with them have always been assumed to belong to other industries.
        </p>
        <p>
          The main aim of this tool is to realize who else can be your potential customer besides your current industry’s clients. This allows you to go beyond the existing demand and increase the size of the Blue Ocean.
        </p>

        <h3>
          How to work with this instrument:
        </h3>

        <p>
          1. Identify the three tiers of noncustomers in your industry, their lifestyle, behavior, and needs.
        </p>
        <p>
          2. Choose tiers of noncustomers for which you will generate your offer.
        </p>
        <p>
          3. Give chosen tiers of noncustomers small names that reflect their main characteristics. Place them under the relevant tier in the model.
        </p>


        <h3>
          Rules:
        </h3>

        <p>
          When you choose tiers of noncustomers, strive for as widest coverage of demand as possible. You can choose one tier of noncustomers or several in case they have something in common.
        </p>

    </>
  )
}
